/**
 * ECharts integration with configurable chart types and filtering
 * @requires https://echarts.apache.org/
 */

import * as echarts from 'echarts'

export default (() => {
  const charts = document.querySelectorAll('.echarts-container')
  if (!charts || charts.length === 0) {
    return
  }

  charts.forEach((chartElement) => {
    const chart = echarts.init(chartElement)

    // Parse options from dataset (or use empty object as fallback)
    let options = chartElement.dataset.chartOptions
      ? JSON.parse(chartElement.dataset.chartOptions)
      : {}

    // Default options (minimal set, can be overridden in HTML)
    const defaultOptions = {
      tooltip: { trigger: 'axis' }, // Default tooltip behavior
      legend: { type: 'scroll', selectedMode: 'multiple' }, // Scrollable legend with filtering
      animation: true,
    }

    // Merge default options with user-provided options
    const mergedOptions = { ...defaultOptions, ...options }

    // Set initial chart options
    chart.setOption(mergedOptions)

    // Handle legend-based filtering (optional, based on series selection)
    chart.on('legendselectchanged', (params) => {
      const selected = params.selected
      const updatedSeries = mergedOptions.series.map((serie) => ({
        ...serie,
        data: selected[serie.name] ? serie.data : [],
      }))
      chart.setOption({ series: updatedSeries })
    })

    // Handle custom filter dropdown (if present)
    const filterSelect = chartElement.nextElementSibling?.classList.contains(
      'echarts-filter'
    )
      ? chartElement.nextElementSibling
      : null

    if (filterSelect) {
      const originalSeries = JSON.parse(JSON.stringify(mergedOptions.series)) // Deep copy
      filterSelect.addEventListener('change', (e) => {
        const selectedValue = e.target.value
        let updatedSeries

        if (selectedValue === 'all') {
          updatedSeries = originalSeries
        } else {
          updatedSeries = originalSeries.map((serie) => ({
            ...serie,
            data: serie.name === selectedValue ? serie.data : [],
          }))
        }
        chart.setOption({ series: updatedSeries })
      })
    }

    // Make chart responsive
    window.addEventListener('resize', () => {
      chart.resize()
    })
  })
})()
